import React, { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import { Close } from '@emotion-icons/material/Close'
import { IconButton } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { Modal } from 'src/components/modal'
import { Steps } from 'src/components/steps'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { PaymentsLoading } from 'src/views/subscriptions/loading'
import { PaymentPlans } from 'src/views/subscriptions/update/payment-plans'
import { PlanReminder } from 'src/views/subscriptions/update/plan-reminder'
import { SelectedPlan } from 'src/views/subscriptions/update/selected-plan'
import { Confirmation } from 'src/views/subscriptions/update/confirmation'
import { SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS, SUBSCRIPTION_MODAL_DIMENSIONS } from 'src/constants/subscriptions'
import { useCloseAndResetSubscriptionModal } from 'src/views/subscriptions/hooks'

import * as paymentsAtoms from 'src/atoms/payments'

const upgradeStepComponents = [<PaymentPlans />, <SelectedPlan />, <Confirmation />]
const downgradeStepComponents = [<PlanReminder />, <SelectedPlan />, <Confirmation />]

const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${Shapes.spacing[6]}px;
`
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${Shapes.spacing[6]}px;
  width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  max-width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  margin: 0 auto;
  & > div {
    flex: 1;
  }
`

export const UpdateSubscriptionModal = () => {
  const subscribeModalOpen = useRecoilValue(paymentsAtoms.subcribeModalOpen)
  const activeStep = useRecoilValue(paymentsAtoms.subscriptionUpdateStep)
  const subscriptionUpdateType = useRecoilValue(paymentsAtoms.subscriptionUpdateType)

  const stepComponents = useMemo(() => {
    return subscriptionUpdateType === 'upgrade' ? upgradeStepComponents : downgradeStepComponents
  }, [subscriptionUpdateType])

  const onCloseAndResetSubscriptionModal = useCloseAndResetSubscriptionModal()

  const onClose = () => onCloseAndResetSubscriptionModal()

  return (
    <Modal
      open={subscribeModalOpen}
      style={{
        height: `${SUBSCRIPTION_MODAL_DIMENSIONS.height}px`,
        width: `100%`,
        maxWidth: `${SUBSCRIPTION_MODAL_DIMENSIONS.width}px`,
      }}>
      <ModalContent>
        <Header>
          <IconButton
            style={{
              position: `absolute`,
              top: `${Shapes.spacing[5]}px`,
              right: `${Shapes.spacing[5]}px`,
            }}
            onClick={onClose}>
            <Close size={24} color={Colors.textDark} />
          </IconButton>
          <Steps activeStep={activeStep} steps={['Plans', 'Payment', 'Confirmation']} />
        </Header>
        <ErrorBoundary>
          <React.Suspense fallback={<PaymentsLoading />}>{stepComponents[activeStep]}</React.Suspense>
        </ErrorBoundary>
      </ModalContent>
    </Modal>
  )
}
